import React, { useEffect } from "react";
import { notification } from "antd";

interface ToastHostProps {
  message: string | null;
  type: "success" | "error";
  onClear: () => void;
}

const ToastHost = ({ message, type, onClear }: ToastHostProps) => {
  useEffect(() => {
    if (!message) return;
    notification[type]({ message, duration: 2.4 });
    const timer = window.setTimeout(onClear, 2500);
    return () => window.clearTimeout(timer);
  }, [message, type, onClear]);

  return null;
};

export default ToastHost;
